import {
  SetLoanSettingsAction,
  SetRemoteConfigAction,
  SetSettingsAction,
  SetSettingsErrorAction,
  SetSettingsSuccessAction,
  SetSettingsKeysAction,
} from '@portal/actions/settings';

import {
  SET_LOAN_SETTINGS,
  SET_REMOTE_CONFIG,
  SET_SETTINGS,
  SET_SETTINGS_ERROR,
  SET_SETTINGS_SUCCESS,
  SET_SETTINGS_KEYS,
} from '~/actions/actionTypes';

const initialState: reducers.SettingsReducer = {
  remoteConfig: null,
  settings: null,
  keys: null,
  loanSettings: null,
  error: null,
  success: null,
};

const settingsReducer = (
  state = initialState,
  action:
    | SetLoanSettingsAction
    | SetSettingsAction
    | SetRemoteConfigAction
    | SetSettingsErrorAction
    | SetSettingsSuccessAction
    | SetSettingsKeysAction
): reducers.SettingsReducer => {
  const { type, payload } = action;

  switch (type) {
    case SET_SETTINGS:
      return {
        ...state,
        settings: payload as models.Settings,
      };
    case SET_REMOTE_CONFIG:
      return {
        ...state,
        remoteConfig: payload as models.RemoteConfig | null,
      };
    case SET_LOAN_SETTINGS:
      return {
        ...state,
        loanSettings: payload as models.LoanSettings | null,
      };
    case SET_SETTINGS_ERROR:
      if (!(payload instanceof Error) && payload !== null) {
        return state;
      }

      return {
        ...state,
        error: payload,
      };
    case SET_SETTINGS_SUCCESS:
      if (typeof payload !== 'string' && payload !== null) {
        return state;
      }

      return {
        ...state,
        success: payload,
      };

    case SET_SETTINGS_KEYS:
      return {
        ...state,
        keys: payload as models.SettingsKeys[],
      };

    default:
      return state;
  }
};

export default settingsReducer;
